<template>
    <div>
        <div class="flex items-center mb-4">
            <button
                class="text-indigo-500 hover:underline mr-4"
                @click="$router.push({ name: 'finnancial.cashout-release.blocked-products' })"
            >
                &larr; Voltar
            </button>
            <h2 class="text-gray-400 text-lg">Usuários com Saldo Retido - Produto #{{ productId }}</h2>
        </div>

        <div v-if="loading" class="text-center py-8 text-gray-400">
            Carregando...
        </div>

        <div v-else>
            <div class="bg-slate-800 rounded-lg p-4 mb-6">
                <h3 class="text-white text-lg mb-2">Informações do Produto</h3>
                <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div>
                        <p class="text-gray-400 text-sm">Nome</p>
                        <p class="text-white">{{ product?.name }}</p>
                    </div>
                    <div>
                        <p class="text-gray-400 text-sm">Status</p>
                        <product-status :status="product?.status" />
                    </div>
                    <div>
                        <p class="text-gray-400 text-sm">Produtor</p>
                        <button
                            class="text-indigo-500 hover:underline"
                            @click.prevent="goToUser(product?.user)"
                        >
                            {{ product?.user?.name }}
                        </button>
                    </div>
                    <div>
                        <p class="text-gray-400 text-sm">Total Retido</p>
                        <p class="text-white text-xl font-bold">{{ $root.formatCurrency(totalBlockedAmount || 0) }}</p>
                    </div>
                </div>
            </div>

            <h3 class="text-gray-400 text-lg mb-4">Usuários Impactados</h3>

            <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="overflow-hidden not-prose relative bg-slate-50 rounded-xl overflow-hidden dark:bg-slate-800/25">
                        <table class="border-collapse table-auto w-full text-sm">
                            <thead>
                                <tr class="text-white">
                                    <th scope="col" class="text-sm font-medium px-6 py-4 text-left">
                                        Usuário
                                    </th>
                                    <th scope="col" class="text-sm font-medium px-6 py-4 text-left">
                                        Email
                                    </th>
                                    <th scope="col" class="text-sm font-medium px-6 py-4 text-left">
                                        Qtd. Payables
                                    </th>
                                    <th scope="col" class="text-sm font-medium px-6 py-4 text-left">
                                        Valor Retido
                                    </th>
                                    <th scope="col" class="text-sm font-medium px-6 py-4 text-left">
                                        Status
                                    </th>
                                    <th scope="col" class="text-sm font-medium px-6 py-4 text-left">
                                        Ações
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="bg-white dark:bg-slate-800">
                                <tr v-if="users.length === 0">
                                    <td colspan="6" class="text-center py-4 text-gray-400">
                                        Nenhum usuário com saldo retido encontrado.
                                    </td>
                                </tr>
                                <tr v-for="user in users" :key="user.user_id">
                                    <td class="border-b border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-200">
                                        <button
                                            class="text-indigo-500 hover:underline"
                                            @click.prevent="goToUserById(user.user_id)"
                                        >
                                            {{ user.user_name }}
                                        </button>
                                    </td>
                                    <td class="border-b border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-200">
                                        {{ user.user_email }}
                                    </td>
                                    <td class="border-b border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-200">
                                        {{ user.payables_count }}
                                    </td>
                                    <td class="border-b border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-200">
                                        {{ $root.formatCurrency(user.total_amount || 0) }}
                                    </td>
                                    <td class="border-b border-slate-100 dark:border-slate-700 p-4 pl-8">
                                        <span
                                            v-if="user.already_released"
                                            class="bg-green-500 text-white text-sm font-medium px-2.5 py-1.5 rounded"
                                        >
                                            Liberado
                                        </span>
                                        <span
                                            v-else
                                            class="bg-red-500 text-white text-sm font-medium px-2.5 py-1.5 rounded"
                                        >
                                            Bloqueado
                                        </span>
                                    </td>
                                    <td class="border-b border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-200">
                                        <button
                                            v-if="!user.already_released"
                                            class="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                                            @click.prevent="openReleaseModal(user)"
                                        >
                                            Liberar Saque
                                        </button>
                                        <span v-else class="text-green-400">
                                            Já liberado
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de Liberação -->
        <div
            v-if="showModal"
            class="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
            @click.self="closeModal"
        >
            <div class="bg-slate-800 rounded-lg p-6 w-full max-w-md">
                <h3 class="text-white text-lg mb-4">Liberar Saque</h3>
                <p class="text-gray-400 mb-4">
                    Você tem certeza que deseja liberar os saques para <strong class="text-white">{{ selectedUser?.user_name }}</strong>?
                </p>
                <p class="text-gray-400 mb-4">
                    Valor retido: <strong class="text-white">{{ $root.formatCurrency(selectedUser?.total_amount || 0) }}</strong>
                </p>
                <div class="mb-4">
                    <label class="block text-gray-400 text-sm mb-2">Motivo (obrigatório)</label>
                    <textarea
                        v-model="releaseReason"
                        class="w-full bg-slate-700 text-white rounded p-2 border border-slate-600 focus:border-indigo-500 focus:outline-none"
                        rows="3"
                        placeholder="Descreva o motivo da liberação (mínimo 10 caracteres)..."
                    ></textarea>
                    <p v-if="releaseError" class="text-red-500 text-sm mt-1">{{ releaseError }}</p>
                </div>
                <div class="flex justify-end space-x-2">
                    <button
                        class="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
                        @click="closeModal"
                    >
                        Cancelar
                    </button>
                    <button
                        class="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50"
                        :disabled="releasing"
                        @click="releaseCashout"
                    >
                        {{ releasing ? 'Liberando...' : 'Confirmar Liberação' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProductStatus from "../../../components/layouts/ProductStatus.vue";
import { mapWritableState } from "pinia";
import { Store } from "../../../stores/store";

export default {
    components: { ProductStatus },
    data() {
        return {
            loading: false,
            product: null,
            users: [],
            totalBlockedAmount: 0,
            showModal: false,
            selectedUser: null,
            releaseReason: '',
            releaseError: '',
            releasing: false,
        };
    },

    computed: {
        ...mapWritableState(Store, ['user']),
        productId() {
            return this.$route.params.product_id;
        }
    },

    mounted() {
        this.fetch();
    },

    methods: {
        fetch() {
            this.loading = true;

            axios.get(`/api/financial/cashout-release/product/${this.productId}`)
                .then(({ data }) => {
                    this.product = data.product;
                    this.users = data.users;
                    this.totalBlockedAmount = data.total_blocked_amount;
                })
                .catch((error) => {
                    console.error('Erro ao carregar dados do produto:', error);
                    this.$notify({
                        group: 'error',
                        title: 'Erro',
                        text: 'Erro ao carregar dados do produto.'
                    }, 4000);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        goToUser(user) {
            if (!user) return;
            this.user = user;
            this.$router.push({
                name: 'user.commissions',
                params: { user_id: user.id }
            });
        },
        goToUserById(userId) {
            this.$router.push({
                name: 'user.commissions',
                params: { user_id: userId }
            });
        },
        openReleaseModal(user) {
            this.selectedUser = user;
            this.releaseReason = '';
            this.releaseError = '';
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.selectedUser = null;
            this.releaseReason = '';
            this.releaseError = '';
        },
        releaseCashout() {
            if (this.releaseReason.length < 10) {
                this.releaseError = 'O motivo deve ter no mínimo 10 caracteres.';
                return;
            }

            this.releasing = true;
            this.releaseError = '';

            axios.post('/api/financial/cashout-release/release', {
                user_id: this.selectedUser.user_id,
                reason: this.releaseReason
            })
                .then(({ data }) => {
                    this.$notify({
                        group: 'success',
                        title: 'Sucesso',
                        text: data.message || 'Saque liberado com sucesso!'
                    }, 4000);
                    this.closeModal();
                    this.fetch();
                })
                .catch((error) => {
                    const message = error.response?.data?.message || 'Erro ao liberar saque.';
                    this.releaseError = message;
                    this.$notify({
                        group: 'error',
                        title: 'Erro',
                        text: message
                    }, 4000);
                })
                .finally(() => {
                    this.releasing = false;
                });
        }
    }
};
</script>
